var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var H1 = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n"], ["\n    font-family: ", ";\n"])), function (props) { return props.fontFamily || props.theme.typography.font.family.yummo; });
export default H1;
var templateObject_1;
